<section class="planned-giving-section">
  <app-cmn-selector
    [checked]="plannedGiving.plannedGivingInterest"
    [label]="('PLANNED_GIVING_INFO' | translate) || fallbackLabelText"
    ariaLabel="Toggle planned giving interest"
    (toggled)="togglePlannedGivingInterest()"
  ></app-cmn-selector>

  <section *ngIf="plannedGiving.plannedGivingInterest" class="planned-giving-fields">
    <div class="planned-giving-field-grid">
      <app-cmn-input
        [label]="'TELEPHONE' | translate"
        inputId="plannedGivingPhone"
        name="plannedGivingPhone"
        type="tel"
        [required]="!hasPlannedGivingEmail"
        maxlength="14"
        #plannedGivingPhone="ngModel"
        [(ngModel)]="plannedGiving.plannedGivingPhone"
        (valueChanged)="onContactEdited()"
        [control]="plannedGivingPhone"
        [showError]="showError(plannedGivingPhone)"
        [showMaxlengthReached]="showError(plannedGivingPhone) && !!plannedGivingPhone.errors?.['maxlength']"
      ></app-cmn-input>

      <app-cmn-input
        [label]="'EMAIL' | translate"
        inputId="plannedGivingEmail"
        name="plannedGivingEmail"
        type="email"
        email
        [required]="!hasPlannedGivingPhone"
        maxlength="128"
        #plannedGivingEmail="ngModel"
        [(ngModel)]="plannedGiving.plannedGivingEmail"
        (valueChanged)="onContactEdited()"
        [control]="plannedGivingEmail"
        [showError]="showError(plannedGivingEmail)"
      ></app-cmn-input>
    </div>

    <app-cmn-selector
      class="planned-giving-use-donor-toggle"
      [checked]="plannedGiving.useDonorContact"
      [label]="('PLANNED_GIVING_USE_DONOR_CONTACT' | translate) || fallbackUseDonorContactText"
      ariaLabel="Toggle donor contact reuse"
      (toggled)="toggleUseDonorContact()"
    ></app-cmn-selector>
  </section>
</section>
